import { Observable, OperatorFunction } from 'rxjs';
import { endWith, filter } from 'rxjs/operators';

interface EmitOnComplete {
  (): OperatorFunction<unknown, undefined>;
  <T>(value: T): OperatorFunction<unknown, T>;
}

export const emitOnComplete: EmitOnComplete =
  <T>(value?: T) =>
  (obs: Observable<unknown>) =>
    obs.pipe(
      filter<unknown, T>((val): val is never => false),
      endWith(value as T)
    );
